import { BASE_ENDPOINT } from "../../../endpoint";

export const editCollateralService = async (token: string, institutionId: string, loanId: string, collateralId: string, payload: any) => {
    try {
        const response = await fetch(`${BASE_ENDPOINT}/user/loanmanagement/institution/${institutionId}/loanapplication/${loanId}/collateral/${collateralId}`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: payload
        });
        const res = await response.json();
        if (!response.ok) {
            console.error('Error:', res);
            throw new Error(res.message);
        }
        return res;
    } catch (error) {
        console.error('API fetch error:', error);
        throw error;
    }
};
